import { getEntryTarget } from '../captureInteractionTargets';
import { PerformanceLongAnimationFrameTiming } from '../longest-animation-frame/types';
import { getLoAFAdditionalParams } from './getLoAFAdditionalParams';
import { getSelector } from './getSelector';

/**
 * Хелпер для сбора дополнительной информации об элементе, который вызвал INP.
 *
 * @kind helper
 * @param performanceEventTiming Содержимое PerformanceEventTiming при логировании INP.
 * @param longAnimationFrames LoAF которые связаны с INP
 * @returns Дополнительная информация об элементе, который вызвал INP, для отправки в Rum счетчик.
 **/
export function getINPAdditionalParams(
    performanceEventTiming?: Ya.Rum.PerformanceEventTiming | undefined | null,
    longAnimationFrames: PerformanceLongAnimationFrameTiming[] = []
): Record<string, string> | undefined {
    if (!performanceEventTiming) {
        return;
    }

    const { name, entryType, startTime, processingStart, processingEnd } = performanceEventTiming;
    const delayTime = processingStart - startTime;
    const handlerTime = processingEnd - processingStart;

    const scriptTimings = longAnimationFrames.flatMap(x => x.scripts);

    const { scripts, scriptDurations } = getLoAFAdditionalParams({ scriptTimings, relatedInteractions: [] });
    const target = getEntryTarget(performanceEventTiming);

    return {
        // Селектор элемента, который вызвал INP и unknown, если элемент не найден на странице.
        inp_selector: target ? getSelector(target) : 'unknown',
        // Тип связанного события.
        inp_event_name: name,
        // Для первого взаимодействия: "first-input", для последующих событий — "event"
        inp_entry_type: entryType,
        // Задержка ввода перед обработкой события.
        inp_delay_time: String(delayTime),
        // Время обработки события.
        inp_handler_time: String(handlerTime),
        // Скрипты, которые были выполнены во время обработки взаимодействия
        inp_related_scripts: scripts,
        // Время выполнения скриптов
        inp_related_scripts_durations: scriptDurations,
    };
}
